export const LISTE_CONTACTS = {
  title: 'Liste des contacts',
  repertoire: 'Clients',
  racine: 'Accueil',
  actions: {
    filtre: 'Filtre',
    search: 'Rechercher',
    delete: 'Supprimer',
    archive: 'Archiver',
    newCustomer: 'Nouveau Contact',
    newsletter: 'Gestion Newsletter',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    client: 'Clients',
    archive: 'Archivé',
    marque: 'Marque(s)',
    yes: 'Oui',
    no: 'Non',
    newsLetter: 'Newsletter',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  table: {
    customer: 'Client',
    civility: 'Civilité',
    name: 'Nom',
    typeContact: 'Type contact',
    firstname: 'Prénom',
    role: 'Fonction',
    office: 'Service',
    phone: 'Téléphone',
    cellPhone: 'Portable',
    email: 'Email',
    edit: 'Modifier',
    delete: 'Supprimer',
    newsLetter: 'Newsletter',
  },
  popUpNewsletterTitle: 'Etes-vous sûr de vouloir modifier la newsletter sur ce(s) contacts(s)?',
  popUpNewsletterMsgSuccess: 'Modification effectuée avec succès',
};

export const DETAIL_CONTACT = {
  title: 'Détail contact {nomPrenom}',
  customer: 'Client',
  civility: 'Civilité',
  name: 'Nom',
  firstname: 'Prénom',
  office: 'Fonction',
  phone: 'Téléphone',
  portail: 'Portail',
  cellPhone: 'Portable',
  email: 'Email',
  service: 'Service',
  address: 'Adresse',
  identifiant: 'Identifiant :',
  actions: {
    edit: 'Modifier',
  },
  warning: {
    archivedContact: 'Le contact "{name}" est actuellement archivé',
    archivedContacts: 'Les contacts en orange sont actuellement archivés',
    archivedContactSelectedAbove: 'Le contact ci-dessus est actuellement archivé',
  },
  table: {
  },
  button: {
    addContactFromEnseigne: 'Rattacher des contacts',
  },
  newsLetter: 'Accepte newsletter',
};

export const EDITION_CONTACT = {
  titleCreation: 'Créer un contact',
  titleChange: 'Modifier contact {nomPrenom}',
  generalInformations: 'Informations générales',
  identifiantDeConnexion: 'Identifiant de connexion',
  problemOccurred: 'Un problème est survenu',
  name: 'Nom',
  firstname: 'Prénom',
  office: 'Fonction',
  phone: 'Téléphone',
  cellPhone: 'Portable',
  email: 'Email',
  customerName: 'Client',
  civility: 'Civilité',
  service: 'Service',
  address: 'Adresse',
  typeContact: 'Type contact',
  haveAddress: 'Adresse postale différente du client',
  haveAddressCollectivite: 'Adresse postal différente de la collectivité TLPE',
  haveAddressFournisseur: 'Adresse postale différente du fournisseur',
  haveAddressService: 'Adresse postale différente du service',
  postalAddress: 'Adresse postale',
  lienTiers: 'Liaisons client',
  newsLetter: 'Newsletter',
  actions: {
    revert: 'Annuler',
  },
  table: {
  },
  messages: {
    successCreation: 'Création du contact réalisée avec succès.',
    errorCreation: 'Enregistrement du contact impossible. Les champs suivants doivent être renseignés : ',
    errorCreation2: 'Enregistrement du contact impossible.',
    successChange: 'Modification du contact réalisée avec succès.',
    errorChange: 'Modification du contact impossible. Les champs suivants doivent être renseignés : ',
    errorChange2: 'Modification du contact impossible.',
    customerNameNotExist: 'Vous devez sélectionner un client existant.',
    selectCustomer: 'Sélectionnez un client existant…',
    warningMessageAccesPortail: 'Attention, l\'activation du portail rend obligatoire la saisie de l\'email.',
    motDePasseDifferent: 'Le mot de passe et la confirmation du mot de passe sont différents',
    accesPortail: 'Peut accèder au portail',
    deleteContactUtilisateur: 'Le contact ne peut pas être supprimé car il est lié à un utilisateur',
    ajouterCustomer: 'Ajoutez au moins un client pour pouvoir gérer les liaisons',
    errorTiersNotExiste: 'liaison impossible si l\'un des clients n\'existe pas',
    errorNotParent: 'Le tiers sélectionné n\'est pas un parent valide.',
  },
  tabs: {
    contact: 'Contacts',
    portail: 'Portail',
    informations: 'Informations',
    contactsTiers: 'Portail - Site visible',
  },
  identifiant: 'Identifiant',
  motDePasse: 'Mot de passe',
  confirmerMotDePasse: 'Confirmer votre mot de passe',
  accesPortail: 'Portail activé',
  contactsTiers: {
    table: {
      addTiers: 'Ajouter un client',
      noResults: 'Aucune liaison',
    },
  },
};

export const SUPPRIMER_CONTACT = {
  irreversible: 'Cette action est irréversible.',
  delete: 'Etes-vous sûr de vouloir supprimer ce contact ?',
  deleteMultiple: 'Etes-vous sûr de vouloir supprimer ces contacts ?',
  type: 'ce contact ',
  yes: 'Oui',
  no: 'Non',
  messages: {
    error: 'Suppression du contact impossible. Veuillez réessayer ou contacter le service client.',
    suppression: 'Contact supprimé avec succès',
    suppressionMultiple: 'Contacts supprimés avec succès',
    deleteFailed: 'Impossible de supprimer le contact "{nomPrenom}" : il est déjà utilisé dans un(e) devis/commande/facture/plan média',
    deleteContactUtilisateur: 'Impossible de supprimer le contact "{nomPrenom}" : il est lié à un utilisateur',
  },
};

export const ARCHIVER_CONTACT = {
  archive: 'Etes-vous sûr de vouloir archiver ce contact ?',
  archiveSuccess: 'Archivage du contact réalisé avec succès.',
  archiveMultiple: 'Etes-vous sûr de vouloir archiver ces contacts ?',
  archiveMultipleSuccess: 'Archivage des contacts réalisé avec succès.',
  yes: 'Oui',
  no: 'Non',
  showArchive: 'Afficher les contacts archivés ({nombre})',
  messages: {
    error: 'Archivage du contact impossible. Veuillez réessayer ou contacter le service client.',
  },
  archiver: 'Archiver',
};

export const POPUP_AJOUT_CONTACT_TIERS_FROM_PARENT = {
  header: {
    title: 'Ajout de contacts de l\'enseigne à un point de vente',
  },
  tab: {
    prenomNom: 'Nom du contact',
  },
  popUpPreventionAjout: {
    title: 'Confirmer l\'ajout du contact au point de vente',
  },
  actions: {
    addContact: 'Ajouter aux contacts',
  },
};
